import React, { Component } from "react";

import { GenericModal, GenericOption, GenericSelect } from 'com-gyf-webcore-userinterfacecomponents';

import TagWithButton from './TagWithButton';
import PanelesPermisos from './PanelesPermisos';
import { fail } from "assert";
import BusquedaGrupoWindows from './BusquedaGrupoWindows'

let products;
let oProducto;
let oProductoModal;
let profiles;
let oPerfil;
let oGruposWindows;

class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            productId: (this.props.informacionUsuario.productId) ? this.props.informacionUsuario.productId : "-1",
            productIdModal: "0",
            profileId: (this.props.informacionUsuario.profileId) ? this.props.informacionUsuario.profileId : "-1",
            valueNewProfile: "",
            descNewProfile: "",
            warningMessageName: "",
            warningMessageDesc: "",
            profiles: this.props.perfiles,
            gruposWindows: this.props.gruposWindows,
            perfilAgregado: false,
            productoSinPerfil: this.props.productoSinPerfil,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            productoSinPerfil: nextProps.productoSinPerfil
        });
    }

    onModalConfirmClick(event) {
        if (event.type == "click" || (event.type == "keydown" && event.keyCode == 13)) {
            let name = this.state.valueNewProfile;
            let desc = this.state.descNewProfile;
            let productId = this.state.productId;

            let exist = this.props.perfiles.find(function (p) {
                if (p.Id > 0) {
                    return p.Descripcion.toLowerCase() == name.toLowerCase();
                }
            });

            let format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
            let formatDescripcion = /[!@#$%^&*()_+\-=\[\]{};':"\\|<>\/?~]/;

            if (name.trim() == "") {
                this.setState({ warningMessageName: "Ingrese un nombre para el nuevo perfil" });
                return;
            }
            else if (format.test(name)) {
                this.setState({ warningMessageName: "El nombre no debe contener caracteres especiales ni espacios" });
                return;
            }

            if (desc.trim() == "") {
                this.setState({ warningMessageDesc: "Ingrese una descripción para el nuevo perfil" });
                return;
            }
            else if (formatDescripcion.test(desc)) {
                this.setState({ warningMessageDesc: "La descripción no debe contener caracteres especiales" });
                return;
            }

            if (exist) {
                this.setState({ warningMessageName: "El perfil ya existe" });
            }
            else {
                this.props.createPerfil(name, desc, productId);

                this.setState({
                    valueNewProfile: "",
                    descNewProfile: "",
                    warningMessageName: "",
                    warningMessageDesc: "",
                    productId: "-1",
                    productIdModal: "0",
                    profileId: "-1"
                });
            }
        }
    }

    onHandleInputModalChangeName(event) {
        this.setState({
            valueNewProfile: event.target.value,
            warningMessageName: ""
        });
    }

    onHandleInputModalChangeDesc(event) {
        this.setState({
            descNewProfile: event.target.value,
            warningMessageDesc: ""
        });
    }

    onHandleSelectChangeProduct(event) {
        let value = event.target.value;
        let nameUserInfo = event.target.dataset.userinfo;

        this.setState({
            productId: value,
            perfilAgregado: false
        });


        this.props.updateInformacionUsuario(nameUserInfo, value);
        if (value == -1) {
            this.props.limpiarPerfilesFiltrados(value)
        }
        else {
            this.props.getPerfilesByProducto(value)
        }
    }


    onHandleSelectChangeProfile(event) {
        let value = event.target.value;
        let nameUserInfo = event.target.dataset.userinfo;
        this.props.updateInformacionUsuario(nameUserInfo, value);


        if (value == -1)
            return null;

        if (value == 0) {
            this.setState({
                valueNewProfile: "",
                descNewProfile: "",
                warningMessageName: "",
                warningMessageDesc: "",
                perfilAgregado: false
            });
            $("#perfil-modal").modal({ backdrop: "static" });
        }
        else {

            this.setState({ productoSinPerfil: false });
            if (!this.isOnTheProfiles(value)) {
                this.setState({ perfilAgregado: false });
                this.props.addPerfilUsuario(this.props.perfilesFiltrados.find(x => x.Id == value).Codigo, this.state.productId);
                this.setState({ productId: "-1" });

                //resteo combo de productos.
                $('#selProductos').prop('selectedIndex', 0);
            } else {

                this.setState({ perfilAgregado: true });
            }
        }
    }

    onChangeProductModal(event) {
        let id = event.target.value;

        if (id) {
            this.setState({ productIdModal: id });
        }
    }

    isOnTheProfiles(value) {
        let isOnProfilesSelected = false;

        this.props.perfilesDelUsuario.forEach(function (obj) {
            var x = obj.PerfilId.toString();
            if (x === value) {
                isOnProfilesSelected = true;
            }
        });

        return isOnProfilesSelected;
    }

    render() {
        var errorLabelStyle = {
            'color': 'red',
            'margin-top': '5px'
        };

        let me = this;

        products = JSON.parse(JSON.stringify(this.props.productos));

        oProductoModal = products.map(function (product) {
            let selected = product.Id == me.state.productIdModal ? true : false;
            return <GenericOption selected={selected} id={product.Id} description={product.Descripcion} key={"NewProduct_" + product.Id} />
        });

        oProducto = products.map(function (product) {

            let selected = product.Id == me.state.productId ? true : false;

            return <GenericOption selected={selected} id={product.Id} description={product.Descripcion} key={"NewProduct_" + product.Id} />
        });

        profiles = JSON.parse(JSON.stringify(this.props.perfilesFiltrados));

        //Se comenta para que no cachee el combo de Perfil
        //Carga inicial de combo Perfil en cascada con Producto
        //(profiles.length == 0 && oProducto.length > 0) ? this.props.getPerfilesByProducto(oProducto[0].props.id) : profiles; 
        profiles = profiles.sort(function (a, b) {
            if (a.Codigo.toLowerCase() > b.Codigo.toLowerCase()) {
                a.first = false;
                b.first = false;
                return 1;
            }
            if (a.Codigo.toLowerCase() < b.Codigo.toLowerCase()) {
                a.first = false;
                b.first = false;
                return -1;
            }
            return 0;
        });

        oPerfil = profiles.map(function (profile) {
            return <GenericOption id={profile.Id} description={profile.Codigo} key={"NewProfile_" + profile.Id} />
        });

        oGruposWindows = this.props.gruposWindows.map(function (grupo) {
            return <input className="form-control default-input  bottom-separator-xs input-disabled-windows-groups" type="text" value={grupo.nombre} disabled />
        });

        let selectedProfiles = this.props.perfilesDelUsuario.map((p) => {
            return (
                <TagWithButton
                    id={p.PerfilId}
                    descripcion={p.PerfilDescripcion}
                    codigo={p.PerfilCodigo}
                    productoDescripcion={p.ProductoDescripcion}
                    deletePerfilUsuario={this.props.deletePerfilUsuario}
                    configuracionPwType={this.props.configuracionPwType} />
            );
        });

        let componentInModal = (
            <div>
                <div className="form-group bottom-separator-xs">
                    <label className="label-tooltip zmdi-help">El perfil a crear no tendrá permisos y deberá agregarlos manualmente</label>
                </div>

                <div className="form-group bottom-separator-xs">
                    <label className="label-primary">Nombre del perfil</label>
                    <input type="text"
                        className="form-control default-input"
                        maxLength="16"
                        value={this.state.valueNewProfile}
                        onChange={(event) => this.onHandleInputModalChangeName(event)}
                        onKeyDown={(event) => this.onModalConfirmClick(event)} />
                    {this.state.warningMessageName &&
                        <label className="error zmdi-alert-circle">
                            {this.state.warningMessageName}
                        </label>}
                </div>

                <div className="form-group bottom-separator-xs">
                    <label className="label-primary">Descripción</label>
                    <input id="descripcion_perfil"
                        className="form-control default-input"
                        type="text"
                        value={this.state.descNewProfile}
                        maxLength="50"
                        onChange={(event) => this.onHandleInputModalChangeDesc(event)}
                        onKeyDown={(event) => this.onModalConfirmClick(event)} />
                    {this.state.warningMessageDesc &&
                        <label className="error zmdi-alert-circle">
                            {this.state.warningMessageDesc}
                        </label>}
                </div>

                <div className="form-group bottom-separator-xs">
                    <label className="label-primary">Asociar con sistema</label>
                    <GenericSelect id="selProductosModal"
                        options={oProductoModal}
                        className="form-control default-input"
                        onChange={(event) => this.onChangeProductModal(event)} />
                </div>

                {(this.props.gruposWindows.length > 0 && this.props.configuracionPwType.TipoSeguridad == 'AD') ? <div className="form-group bottom-separator-xs">
                    <BusquedaGrupoWindows
                        gruposWindows={this.props.gruposWindows}
                        gruposWindowsSeleccionados={this.props.gruposWindowsSeleccionados}
                        addGroupWindows={this.props.addGroupWindows}
                        deleteGroupWindows={this.props.deleteGroupWindows}
                        resetGrupoWindows={this.props.resetGrupoWindows}
                    />
                </div> : null}

            </div>);

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <h3 className="divisor-section">Perfil</h3>
                        </div>
                    </div>
                    {(selectedProfiles && selectedProfiles.length > 0) ?
                        <div className="row">
                            <div className=" col-xs-12 bottom-separator-xs">
                                {selectedProfiles}
                            </div>
                        </div> : null}
                    <div className="row">
                        <div className="col-xs-3">
                            <select
                                id="selProductos"
                                name="selProductos"
                                data-userinfo="ProductId"
                                className="form-control default-input"
                                onChange={(event) => this.onHandleSelectChangeProduct(event)} >
                                <option value="-1" selected="selected">Seleccione...</option>
                                <option value="0">Todos los productos</option>
                                {oProducto}
                            </select>

                        </div>
                        <div className="col-xs-3">
                            <select
                                id="selPerfiles"
                                name="selPerfiles"
                                data-userinfo="ProfileId"
                                className="form-control default-input"
                                onChange={(event) => this.onHandleSelectChangeProfile(event)}>
                                <option value="-1">Seleccione...</option>
                                {oPerfil}
                            </select>
                            {this.state.productoSinPerfil
                                && <label className="error">{"Debe seleccionar un perfil."}</label>}
                        </div>
                        <div className="col-xs-3">
                            {this.state.perfilAgregado ? <label style={errorLabelStyle}>Perfil ya asignado.</label> : null}
                        </div>
                    </div>
                </div>

                {(this.props.gruposWindows.length > 0 && this.props.configuracionPwType.TipoSeguridad == 'AD') ?
                    (<div className="col-xs-12">
                        <div className="row">
                            <div className="col-xs-12">
                                <h3 className="divisor-section">Grupos de Windows</h3>
                            </div>
                        </div>
                        <div className="row">
                            <div className=" col-xs-4">
                                {oGruposWindows}
                            </div>
                        </div>
                    </div>) :
                    (null)}

                <div className="col-xs-12">
                    <PanelesPermisos
                        permisos={this.props.permisos}
                        addPermiso={this.props.addPermiso}
                        deletePermiso={this.props.deletePermiso}
                        selectProductoPermiso={this.props.selectProductoPermiso}
                        selectCategoriaPermiso={this.props.selectCategoriaPermiso}
                        selectProgramaPermiso={this.props.selectProgramaPermiso}
                        addFuncion={this.props.addFuncion}
                        removeFuncion={this.props.removeFuncion} />
                </div>

                { /* Modal Nuevo Perfil */}
                <GenericModal id="perfil-modal"
                    className="modal fade-out"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic modal-profile"
                    header={<h2 className="modal-title">Nuevo perfil</h2>}
                    footer={
                        <div className="row">
                            <div className="col-xs-5">
                                <button type="button" className="btn btn-cta" onClick={(event) => this.onModalConfirmClick(event)}>Guardar</button>
                            </div>
                            <div className="col-xs-7">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => this.props.resetGrupoWindows()}>Cancelar</button>
                            </div>
                        </div>}
                    body={componentInModal} />

            </div>
        );
    }
}

export default UserProfile;